import React, { useEffect } from 'react';
import { Paper } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import DevicesTable from '../components/DevicesTable';
import { MENU_WIDTH } from '../constants';
import { getCurrentUser } from '../store/actions/auth';

const Devices = () => {
  const useStyles = makeStyles(() => ({
    root: {
      width: '100%',
      paddingLeft: MENU_WIDTH,
      paddingTop: '6rem',
      height: '100%',
    },
    paper: {
      margin: '2em',
    },
    headerRow: {
      display: 'flex',
      flexDirection: 'row',
      marginLeft: '2rem',
      marginTop: '2rem',
      justifyContent: 'flex-end',
      marginRight: '2rem',
    },
    button: {
      color: 'white',
      backgroundColor: '#00d1b2',
      '&:hover': {
        backgroundColor: '#00bca0',
      },
    },
  }));
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.admin.currentUserInfo);

  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);

  const onAddDevice = () => {
    history.push(`../add-monitor`);
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerRow}>
        {currentUser && currentUser.role && currentUser.role.name !== 'HCP' && currentUser.role.name !== 'Supervisor' && (
          <Button className={classes.button} variant="contained" onClick={onAddDevice}>
            Add New Monitor
          </Button>
        )}
      </div>
      <Paper className={classes.paper}>
        <DevicesTable />
      </Paper>
    </div>
  );
};

export default Devices;
